import Vue from 'vue'

const state = {
  active: false,

  // values
  preset: {
    type: 'layoutHeader',
    uuid: null,
    logoImageUseFlg: 0,
    lightOffBtnUseFlg: 0,
    btnCount: 1,
    btnLayoutType: 1,
    roundCornerFlg: 1,
    rectRoundCornerStyle: {
      roundCornerLeftTop: 0,
      roundCornerRightTop: 0,
      roundCornerLeftBottom: 0,
      roundCornerRightBottom: 0
    },
    zIndex: 0
  },
  values: {},
  
  // 設定モード
  isModify: false
}

const getters = {
  get: state => state,
}

const actions = {
  show ({commit}, data) {
    let isModify = data ? true : false
    if (isModify) {
      commit('setValues', $.extend(true, {}, data))
    } else {
      commit('setValues', $.extend(true, {}, state.preset))
    }

    // cover
    this.dispatch('core/showSclCover')
    // show
    commit('showed', isModify)
  },
  hide ({commit}) {
    if (!state.active) return
    // hide
    commit('hided')
    // cover
    setTimeout(() => {
      this.dispatch('core/hideSclCover')
    }, 350)
  },

  /**
   * リセット
   */
  reset ({commit}) {
    commit('reset')
  }
}

const mutations = {
  showed (state, isModify) {
    state.isModify = isModify
    state.active = true
  },
  hided (state) {
    state.active = false
  },

  // form
  setValues (state, values) {
    Vue.set(state, 'values', values)
  },
  setInputValue (state, {keys, value}) {
    if (keys.length === 2) {
      Vue.set(state.values[keys[0]], keys[1], value)
    } else {
      Vue.set(state.values, keys[0], value)
    }
  },

  // reset
  reset (state) {
    Vue.set(state, 'values', {})
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
